import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da692bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alarm-page" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "notice_status_list" }
const _hoisted_5 = {
  class: "notice_status",
  style: {"width":"fit-content"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "notice_status",
  style: {"width":"fit-content"}
}

import { onMounted, ref, watch, computed, nextTick } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'

import { queryAlarmMsgPage, queryAlarmOtherInfoTreelist } from '@/api'
import moment from 'moment'
import { ALARM_LEVEL_TYPE, ALARM_TYPE, CODE_ENUM, PAGE_SIZES } from '@/common'
import { formatFormTime } from '@/utils'
import { isEmpty } from 'lodash'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'warning-table',
  setup(__props) {

const $route = useRoute()

// 等级告警
const levelOps = [
  {
    label: '主要',
    value: ALARM_LEVEL_TYPE.ALARM_MAIN,
  },
  {
    label: '次要',
    value: ALARM_LEVEL_TYPE.ALARM_MINOR,
  },
  {
    label: '紧急',
    value: ALARM_LEVEL_TYPE.ALARM_URGENCY,
  },
  {
    label: '警告',
    value: ALARM_LEVEL_TYPE.ALARM_WARN,
  },
  {
    label: '清除',
    value: ALARM_LEVEL_TYPE.ALARM_CLEAN,
  },
]

const advancedRef = ref()

const tableData: any = ref([])
const formInline = ref({
  triggerTypeCode: '',
  alarmLevelCode: '',
  createTime: [],
  triggerConditionDetail: '',
})

const getMoTime = (keepAliveData: any) => {
  return {
    ...formatFormTime(keepAliveData.createTime, ['startTime', 'endTime']),
  }
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const deviceId = $route.query.deviceId || ''
onMounted(() => {
  querySceneList()
  fetchList()
})

const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}

  const moTime = getMoTime(keepAliveData)
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryAlarmMsgPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    ...moTime,
    deviceId,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const isShowPop = (list: any) => {
  return !isEmpty(list)
}

const getLineClass = (data: any) => {
  return data.channelStatusCode
}

const getNoticeClass = (status: any) => {
  return status || ''
}

const msgPopFormatter = {
  timeMsgAlarm: (value: any) => {
    return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  },
}
const msgPop = (msgDetailInfo: any) => {
  const list = msgDetailInfo.filter(
    (item: any) => item.code !== 'titleMsgAlarm'
  )
  return list.map((item: any) => {
    return {
      ...item,
      value: msgPopFormatter[item.code]
        ? msgPopFormatter[item.code](item.value)
        : item.value,
    }
  })
}

const getStatusPop = (channelDetailInfos: any) => {
  return channelDetailInfos.reduce((mo: any, el: any) => {
    mo = mo.concat(el.channelSingleDetailInfoList || [])
    return mo
  }, [])
}

const sceneList: any = ref([])
const querySceneList = async () => {
  const res: any = await queryAlarmOtherInfoTreelist({
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    sceneList.value = res.data || []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList,
      "btn-span": 6
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "告警场景",
          prop: "triggerConditionDetail"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.triggerConditionDetail,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.triggerConditionDetail) = $event)),
              class: "ws_select",
              clearable: "",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.triggerConditionDetail,
                    label: item.triggerConditionDetail,
                    value: item.triggerConditionDetail
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "告警级别",
          prop: "alarmLevelCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.alarmLevelCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.alarmLevelCode) = $event)),
              class: "ws_select",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(levelOps, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "时间",
          prop: "createTime",
          class: "ws_time_range create-time"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: formInline.value.createTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.createTime) = $event)),
              "unlink-panels": "",
              type: "datetimerange",
              "range-separator": "-",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              editable: false,
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "ws_common_table ws_mt20",
        data: tableData.value
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "告警场景",
            prop: "triggerConditionDetail",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "告警级别",
            prop: "alarmLevelCode",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                class: _normalizeClass(["alarm-level", scope.row.alarmLevelCode])
              }, _toDisplayString(scope.row.alarmLevelValue), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "告警时间",
            prop: "alertTime",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(moment)(scope.row.alertTime).format('YYYY-MM-DD HH:mm:ss')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "推送状态"
          }, {
            default: _withCtx((scope) => [
              (isShowPop(scope.row.channelDetailInfos))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_tooltip, {
                      placement: "bottom",
                      "raw-content": "",
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getStatusPop(
                        scope.row.channelDetailInfos
                      ), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "item"
                            }, [
                              (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(` line ${getLineClass(item)}`),
                                key: index
                              }, _toDisplayString(item.channelValue) + ": " + _toDisplayString(item.channelStatusName), 3))
                            ]))
                          }), 128))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.channelSummaryInfos, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: _normalizeClass(`text ${getNoticeClass(scope.row)}`)
                            }, _toDisplayString(item.channelName) + ": " + _toDisplayString(item.channelTotal), 3))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.channelSummaryInfos, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: _normalizeClass(`text ${getNoticeClass(scope.row)}`)
                        }, _toDisplayString(item.channelName) + ": " + _toDisplayString(item.channelTotal), 3))
                      }), 128))
                    ])
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ])
  ]))
}
}

})